import queryString from 'query-string'
import { Banner, Division, Fragment, Loading } from '../../components'
import { loadFragments } from '../../store'
import { parseEmail } from './helpers'
import { EmailMp, PreAction } from './index'
import { SHOW_PRE_ACTION } from '../../constants'
import { rsv, useStyles } from './styles'
import { locationLookup } from '../../helpers'
import SignPetitionForm from './Petition/SignPetitionForm'

const Action = () => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [cookies] = useCookies()
  const [preAction, setPreAction] = useState(
    !cookies['neu_nclb_client']?.token && SHOW_PRE_ACTION
  )
  const [postcode, setPostcode] = useState()
  const [loaded, setLoaded] = useState(false)
  const [emailBody, setEmailBody] = useState()
  const [actionType, setActionType] = useState()
  const [constituency, setConstituency] = useState()

  /* Load fragments */
  useEffect(() => {
    dispatch(loadFragments())
    dispatch({
      type: 'local/upsert',
      payload: { header: !preAction, footer: !preAction },
    })
  }, [])
  const fragments = useSelector((state) => state.local.fragments)

  /* Get constituency data & prep email */
  useEffect(() => {
    if (!!fragments && !_.isEmpty(fragments)) {
      // Action type
      const parsed = queryString.parse(location.search)
      const newActionType = parsed.type || 'email'
      setActionType(newActionType)

      if (newActionType === 'email') {
        locationLookup()
          .then((res) => {
            if (!res || (res && !res.constituency)) window.history.back()
            setPostcode(res.postcode)
            setConstituency(res.constituency)
            return parseEmail(fragments['action_email_body'].content, res.constituency)
          })
          .then((parsedEmail) => setEmailBody(parsedEmail))
          .then(() => setLoaded(true))
      } else setLoaded(true)
    }
  }, [fragments])

  const onClosePreAction = () => {
    setPreAction(false)
    dispatch({
      type: 'local/upsert',
      payload: { header: true, footer: true },
    })
  }

  return preAction ? (
    <Fade in={!_.isEmpty(fragments) && preAction}>
      <PreAction onClose={onClosePreAction} />
    </Fade>
  ) : (
    <Container maxWidth={false} disableGutters>
      <Fade in={!_.isEmpty(fragments)}>
        <Banner
          title="LEFT BEHIND"
          titleExtra="NO CHILD"
          preTitle="take action to demand:"
          img={fragments['action_banner_image']}
        />
      </Fade>
      <Loading show={!loaded} light />
      <Fade in={loaded}>
        <Grid container direction="column" justify="center">
          <Grid item className={classes.content} {...rsv}>
            <Typography variant="h4" align="center">
              <Fragment
                title={`action_${actionType}_section_1_title`}
                {...{ fragments }}
              />
            </Typography>
            <Division padding={15} />
            <Typography variant="body1" component="div" align="left">
              <Fragment
                title={`action_${actionType}_section_1_content`}
                {...{ fragments }}
              />
            </Typography>
          </Grid>
          <Grid
            item
            container
            className={classes.gridClear}
            direction="column"
            alignContent="center"
          >
            {loaded && actionType === 'email' && (
              <EmailMp {...{ rsv, fragments, emailBody, postcode }} />
            )}
            {loaded && actionType === 'petition' && (
              <SignPetitionForm {...{ rsv, fragments, constituency, postcode }} />
            )}
          </Grid>
        </Grid>
      </Fade>
    </Container>
  )
}

export default Action
